import { ControlSettingsModel } from "./control-settings.model";

export class ControlSettingsUiDataModel {
    Sections:ControlSettingsModel[]=[];

    constructor(sections:ControlSettingsModel[]){
        this.Sections = sections;
    }

    public static map(model:any):ControlSettingsUiDataModel{
        var sections:ControlSettingsModel[] = [];
        model.Sections.forEach(c => {
            let sp = ControlSettingsModel.map(c);
            
            sections.push(sp);
        });

        return new ControlSettingsUiDataModel(sections);
    }
}
